module.exports = __webpack_public_path__ + "img/board5-GLX-pink-49.905e398b.jpg";